import { NavTabs } from "@/components/shared/nav-tabs";

import { buildGiftCardHistoryTabs, getGiftCardHistoryActiveHref } from "./lib";
import type { GiftCardHistoryTab } from "./types";

interface GiftCardHistoryFilterProps {
  basePath: string;
  activeTab?: GiftCardHistoryTab;
}

export const GiftCardHistoryFilter = ({ basePath, activeTab }: GiftCardHistoryFilterProps) => {
  return (
    <NavTabs
      items={buildGiftCardHistoryTabs(basePath)}
      active={getGiftCardHistoryActiveHref(basePath, activeTab)}
      align="start"
    />
  );
};
